import { render, staticRenderFns } from "./squidtoon.vue?vue&type=template&id=541527ad&scoped=true"
import script from "./squidtoon.vue?vue&type=script&lang=js"
export * from "./squidtoon.vue?vue&type=script&lang=js"
import style0 from "./squidtoon.vue?vue&type=style&index=0&id=541527ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541527ad",
  null
  
)

export default component.exports